var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "d-flex align-center ga-4",
      attrs: { "data-qa": "lpu_feature_item" },
    },
    [
      _c(_setup.MaskIcon, {
        staticClass: "flex-shrink-0 text-lpu-branding-color-primary",
        attrs: {
          "data-qa": "lpu_feature_item_icon",
          src: _vm.feature.iconSrc,
          size: 32,
        },
      }),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "text-body-1 text--text",
          attrs: { "data-qa": "lpu_feature_item_label" },
        },
        [_vm._v("\n    " + _vm._s(_setup.tStatic(_vm.feature.label)) + "\n  ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }